import React from 'react';
import { DateTime } from 'luxon';

import { CoachProfileModel } from 'app/models/scheduling/CoachProfileModel';
import { AvailableSlotModel } from 'app/models/scheduling/AvailableSlotModel';

import DayRow from './DayRow';
import { useTranslation } from 'react-i18next';

import styles from './DateTime.module.scss';

/**
 * Typed at last, and that is the point of it: this panel handed `DayRow` a
 * `submitForm` of `null` while `DayRow` declares one it will call, and with the
 * props untyped nothing said so. Picking a time in the multi-coach view threw
 * "submitForm is not a function" out of the timeout in `TimeSlot`.
 */
type PropsDef = {
  currentDay: DateTime;
  coach: CoachProfileModel;
  timeSlots: AvailableSlotModel[];
  index: number;
  submitForm: () => void;
};

const DaysPanelForAllCoaches = ({
  currentDay,
  coach,
  timeSlots,
  index,
  submitForm,
}: PropsDef) => {
  const { t } = useTranslation();
  const timeHeader = (text, index) => {
    return (
      <div className={styles.time_header_container}>
        {index === 0 && <div className={styles.time_header_text}>{text}</div>}
      </div>
    );
  };

  return (
    <div className={styles.multi_coach_day_panel_container}>
      {timeHeader(t("Morning"), index)}
      <div className={styles.half_of_day}>
        <DayRow
          coach={coach}
          day={currentDay}
          current={true}
          multiCoach
          timeSlots={timeSlots
            .filter((s) => s.startHour.hasSame(currentDay, 'day'))
            .filter(
              (s) =>
                s.endHour.hour < 12 ||
                (s.endHour.hour === 12 && s.endHour.minute === 0)
            )}
          singleDay={true}
          submitForm={submitForm}
        />
      </div>
      {timeHeader(t('Afternoon'), index)}
      <div className={styles.half_of_day}>
        <DayRow
          coach={coach}
          day={currentDay}
          current={true}
          multiCoach
          timeSlots={timeSlots
            .filter((s) => s.startHour.hasSame(currentDay, 'day'))
            .filter((s) => s.startHour.hour >= 12)}
          singleDay={true}
          submitForm={submitForm}
        />
      </div>
    </div>
  );
};

export default DaysPanelForAllCoaches;
